
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { ServiceBase } from '@app/services/base.service';
import { Cidade } from '@app/models/cidade';
@Injectable()
export class CidadeService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  gravar(orgaosDoJudiciario: Cidade): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'configuracoes/cidade', orgaosDoJudiciario).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `configuracoes/cidade/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/cidade/${id}`, { headers: { meta: ['search'] }});
  }

  obterLista(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `configuracoes/cidade/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

  obterTodos(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/cidade`);
  }

}
